import { Immutable } from "immer";
import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

type IProps = Immutable<
    | { className?: string; html: string; children?: never }
    | { className?: string; html?: never; children: React.ReactNode }
>;

export const OprahTitle = (props: IProps): React.JSX.Element => {
    const className = concatClassNames([styles.oprahTitle, props.className]);
    if (props.html !== undefined) {
        return (
            <div
                className={className}
                dangerouslySetInnerHTML={{ __html: props.html }}
            ></div>
        );
    }
    return <div className={className}>{props.children}</div>;
};
